import { makeStyles, shorthands } from "@fluentui/react-components";

const useOptionsStyles = makeStyles({
  header: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "12px",
    ...shorthands.gap("12px"),
  },

  headerInputContainer: {
    display: "flex",
    ...shorthands.gap("16px"),
    maxWidth: "100%",
    overflowX: "hidden",
    flexWrap: "wrap",
  },

  headerButtonsContainer: {
    display: "flex",
    justifyContent: "flex-end",
  },

  headerButtons: {
    display: "flex",
    ...shorthands.gap("8px"),
  },
});

export default useOptionsStyles;
